/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import { PatientFavoriteClinic, PatientFavoriteClinicFromJSON, PatientFavoriteClinicToJSON } from "../models";

export interface AddFavoriteClinicsRequest {
  patientFavoriteClinic: PatientFavoriteClinic;
}

export interface DeleteFavoriteClinicRequest {
  clinicId: number;
}

/**
 *
 */
export class FavoriteClinicApi extends runtime.BaseAPI {
  /**
   * Add patient favorite clinics
   */
  async addFavoriteClinicsRaw(
    requestParameters: AddFavoriteClinicsRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PatientFavoriteClinic>> {
    if (requestParameters.patientFavoriteClinic === null || requestParameters.patientFavoriteClinic === undefined) {
      throw new runtime.RequiredError(
        "patientFavoriteClinic",
        "Required parameter requestParameters.patientFavoriteClinic was null or undefined when calling addFavoriteClinics."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/favorite-clinics`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: PatientFavoriteClinicToJSON(requestParameters.patientFavoriteClinic),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PatientFavoriteClinicFromJSON(jsonValue));
  }

  /**
   * Add patient favorite clinics
   */
  async addFavoriteClinics(
    requestParameters: AddFavoriteClinicsRequest,
    initOverrides?: RequestInit
  ): Promise<PatientFavoriteClinic> {
    return promiseRetry(
      (retry) =>
        this.addFavoriteClinicsRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Delete patient favorite clinic
   */
  async deleteFavoriteClinicRaw(
    requestParameters: DeleteFavoriteClinicRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PatientFavoriteClinic>> {
    if (requestParameters.clinicId === null || requestParameters.clinicId === undefined) {
      throw new runtime.RequiredError(
        "clinicId",
        "Required parameter requestParameters.clinicId was null or undefined when calling deleteFavoriteClinic."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/favorite-clinics/{clinic_id}`.replace(
          `{${"clinic_id"}}`,
          encodeURIComponent(String(requestParameters.clinicId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PatientFavoriteClinicFromJSON(jsonValue));
  }

  /**
   * Delete patient favorite clinic
   */
  async deleteFavoriteClinic(
    requestParameters: DeleteFavoriteClinicRequest,
    initOverrides?: RequestInit
  ): Promise<PatientFavoriteClinic> {
    return promiseRetry(
      (retry) =>
        this.deleteFavoriteClinicRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
